import { createApiWikifolioPortfolioUrl } from "src/constants/urls";
import { IQueryOptions } from "src/lib/tanstack-query/hooks/use-query";
import { useQuery } from "src/lib/tanstack-query/hooks/use-query";
import { IPortfolioResponse } from "./portfolio-table.api.types";
import { portfolioKeys } from "./portfolio.query-keys";

export const usePortfolioTableQuery = (fullName: string, options: IQueryOptions<IPortfolioResponse>) =>
    useQuery<IPortfolioResponse>({
        url: createApiWikifolioPortfolioUrl(fullName),
        queryKey: portfolioKeys.table(fullName),
        // Dev-Note: we want to refetch data every 10 seconds for the portfolio table
        staleTime: 10_000,
        refetchInterval: 10_000,
        retry: 1,
        ...options,
    });
